'use strict';

// Constructor
var PromotionalBar = function () {
    $('.block-block-content-promotional-bar .paragraph--type--promotional-box').matchHeight();

    $('.block-block-content-promotional-bar .paragraph--type--promotional-box .field--name-field-link a').each(function () {
        var $link = $(this).attr('href');
        var $target = "_self";
        var $parent = $(this).closest('.inner');
        
        // Get rid of the link
        $(this).closest('.field--name-field-link').remove();
        
        // Grab the HTML
        var $html = $($parent).html();

        // Set the target if external then open in new tab
        $link.indexOf('http://') !== -1 ? $target = "_blank" : $target = "_self";

        // Wrap the HTML in link
        $($parent).html('<a href="' + $link + '" target="' + $target + '">' + $html + '</a>');
    });

};

module.exports = PromotionalBar;
